import { IconProp } from '@fortawesome/fontawesome-svg-core';

type SearchItemCategory = 'recently_searched' | 'projects' | 'pitch_decks';

export type SearchResult = {
  url: string;
  label: string;
  category: SearchItemCategory;
  image?: string;
  details?: string;
  status?: string;
  icon?: IconProp;
};

const getProjectSearchResultsFromLocalStorage = (): SearchResult[] => {
  const data = localStorage.getItem('np_projectSearchResults');
  return data ? JSON.parse(data) : [];
};

const getPitchDeckSearchResultsFromLocalStorage = (): SearchResult[] => {
  const data = localStorage.getItem('np_pitchDeckSearchResults');
  return data ? JSON.parse(data) : [];
};

const getRecentSearchesFromLocalStorage = (): SearchResult[] => {
  const data = localStorage.getItem('np_recentSearches');
  return data ? JSON.parse(data) : [];
};

export const setRecentSearchesFromLocalStorage = (newItem: SearchResult) => {
  let items = getRecentSearchesFromLocalStorage();

  // Add the new item to the beginning of the array
  items.unshift(newItem);

  // Ensure we only keep the last 5 items
  if (items.length > 5) {
    items = items.slice(0, 5);
  }
  //don't add duplicates
  items = items.filter(
    (item, index, self) => index === self.findIndex(t => t.label === item.label)
  );

  //   {
  //     "url": "/apps/project-management/project-details/6f55ab5e-734b-4f19-9cca-a128946414b8",
  //     "image": "https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_6f55ab5e-734b-4f19-9cca-a128946414b8_1_project_img.jpg",
  //     "label": "Empty",
  //     "details": "8GB Memory - 1.6GHz - 128GB Storage",
  //     "category": "projects"
  //   },

  localStorage.setItem('np_recentSearches', JSON.stringify(items));
};

// export const getSearchItems = (): SearchResult[] => {
//   return getSearchItemsFromLocalStorage();
// };

// export const addSearchItem = (newItem: SearchResult) => {
//   const currentItems = getSearchItemsFromLocalStorage();
//   currentItems.push(newItem);
//   setSearchItemsToLocalStorage(currentItems);
// };

//lmit this to 5 for
//should recent searches set the searchterm to be whatever you clicked and run the search again?
export const recentSearches: SearchResult[] =
  getRecentSearchesFromLocalStorage();

export const projectSearchResults: SearchResult[] =
  getProjectSearchResultsFromLocalStorage();

export const pitchDeckSearchResults: SearchResult[] =
  getPitchDeckSearchResultsFromLocalStorage();
// [
//   {
//     "url": "/apps/e-commerce/customer/product-details",
//     "label": "Store Macbook Test st",
//     "category": "recently_searched"
//   },
//   {
//     "url": "/apps/e-commerce/customer/product-details",
//     "label": "MacBook Air - 13″ Json",
//     "category": "recently_searched"
//   }
// ]

// [
//   {
//     "url": "/apps/project-management/project-details/6f55ab5e-734b-4f19-9cca-a128946414b8",
//     "image": "https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_6f55ab5e-734b-4f19-9cca-a128946414b8_1_project_img.jpg",
//     "label": "Empty",
//     "details": "8GB Memory - 1.6GHz - 128GB Storage",
//     "category": "projects"
//   },
//   {
//     "url": "/apps/project-management/project-details/38be2137-ae8b-4b4a-a148-bf8aa131f8ae",
//     "image": "https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_6f55ab5e-734b-4f19-9cca-a128946414b8_1_project_img.jpg",
//     "label": "Bango",
//     "details": "30 Sep at 12:30 PM",
//     "category": "projects"
//   }
// ]

// [
//   {
//     "url": "pages/slide-editor/6f55ab5e-734b-4f19-9cca-a128946414b8/e033d621-fbbc-4e8d-9a0e-0e31034894d5",
//     "label": "Support MacBook House st",
//     "category": "pitch_decks"
//   },
//   {
//     "url": "/apps/e-commerce/customer/product-details",
//     "label": "Store MacBook″",
//     "category": "pitch_decks"
//   },
//   {
//     "url": "/apps/e-commerce/customer/product-details",
//     "label": "Library MacBook folder.rar",
//     "category": "pitch_decks"
//   }
// ]
